import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  effect,
  inject,
  input,
  OnInit,
  output,
} from '@angular/core';

import { Icon, IconComponent } from '@web/shared/ui';
import { InputNumber } from 'primeng/inputnumber';
import { FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { debounceTime } from 'rxjs';

@Component({
  selector: 'app-public-cart-quantity',
  imports: [IconComponent, InputNumber, ReactiveFormsModule],
  templateUrl: './public-cart-quantity.component.html',
  styleUrl: './public-cart-quantity.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicCartQuantityComponent implements OnInit {
  private readonly builder = inject(FormBuilder);

  public readonly disabled = input<boolean>(false);
  public readonly quantityChangeEvent = output<number>();
  public readonly quantity = input<number>(1);

  protected readonly Icon = Icon;
  protected readonly formControl = this.prepareQuantityFormControl();

  private readonly destroyRef = inject(DestroyRef);
  private readonly debounceTime = 300;

  public constructor() {
    effect(() => this.enableOrDisableControl());
    effect(() => this.fillQuantityByValue());
  }

  public ngOnInit(): void {
    this.fillQuantityByValue();
    this.listenToValueChanges();
  }

  private prepareQuantityFormControl(): FormControl<number> {
    return this.builder.nonNullable.control<number>(0);
  }

  private listenToValueChanges(): void {
    this.formControl.valueChanges
      .pipe(
        debounceTime(this.debounceTime),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((value) => {
        this.quantityChangeEvent.emit(value);
      });
  }

  private fillQuantityByValue(): void {
    this.formControl.setValue(this.quantity(), {
      emitEvent: false,
    });
  }

  private enableOrDisableControl(): void {
    this.disabled()
      ? this.formControl.disable({ emitEvent: false })
      : this.formControl.enable({ emitEvent: false });
  }
}
